<template>
  <RF-Dialog :data-time="time"
    :cpntStatus='statusGeral'
    :cpntLargura='"700px"'
    :cpntTitulo='" Upload imagem usuário"'
    :cpntOnFecharDialog='usuarioUploadImagemFechar'>
    <template slot='conteudo'>
      <table style="margin: 10px 0px; width: 100%;">
        <tr>
          <td ref="drop" :class="classes">
            <!-- ({{ [ '', null, undefined ].indexOf(imagem) === -1 }})
            ({{ imagem }}) -->
            <div class="meu-usu-icone" title="Clique aqui para alterar a imagem." :key="'div-' + time">
              <!-- SETA A IMAGEM -->
              <img :key="'img-' + time" :src="imagem" v-if="[ '', null, undefined ].indexOf(imagem) === -1" />

              <!-- SETA O ICONE PARA SEM IMAGEM -->
              <svg :key="'img-' + time" class="fas fa-user" v-else></svg>
            </div>

            <!-- SETA O INPUT PARA UPLOAD -->
            <input id="usu-upl-img-input" name="files[]" type="file" :disabled="disabled" @change="usuarioUploadImagemDrag"/>
            <label for="usu-upl-img-input"><strong>Escolha um arquivo</strong><span> ou arraste-o aqui</span>.</label>
          </td>
          <td style="padding-left: 10px; vertical-align: top;">
            <p><b>Atenção - Informações do arquivo</b></p>
            <p>Antes de enviar seu arquivo, confira se o mesmo possui a seguinte formatação:</p>

            <div>
              <p>
                <b>Formato do arquivo </b>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                <span> PNG</span>
              </p>

              <p>
                <b>Largura </b>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                <span> 80px</span>
              </p>

              <p>
                <b>Altura </b>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                <span> 80px</span>
              </p>
            </div>
          </td>
        </tr>
      </table>
    </template>
  </RF-Dialog>
</template>

<style>
  .usu-upl-img {
    width: 360px;
    outline: 2px dashed #92b0b3;
    outline-offset: -10px;
    -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: outline-offset .15s ease-in-out, background-color .15s linear;
    background-color: #c8dadf;
    position: relative;
    padding: 30px 20px;
    text-align: center;
    transition: all 0.3s ease-in-out;
  }
    .usu-upl-img > input {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }
      .usu-upl-img > label {
        cursor: pointer;
        color: #0f3c4b;
        font-size: var(--font-base-soma-15);
      }
      .usu-upl-img > label:hover strong {
        color: #39bfd3;
        font-weight: bold;
      }
  /* .rf-icone-enviando {
    font-size: var(--font-base-soma-45);
    color: var(--color-base-02);
  }
   */
  .usu-upl-img-dragover {
    outline-offset: -20px;
    outline-color: #c8dadf;
    background-color: #f9f9f9;
  }

.meu-usu-icone {
  border: 1px solid #ccc;
  background: #fff;
  padding: 20px;
  border-radius: 50%;
  margin: 0px auto;
  margin-bottom: 15px;
  width: 100px;
  height: 100px;
  cursor: pointer;
  -webkit-box-shadow: 18px 15px 20px -25px rgba(0,0,0,0.75);
  -moz-box-shadow: 18px 15px 20px -25px rgba(0,0,0,0.75);
  box-shadow: 18px 15px 20px -25px rgba(0,0,0,0.75);
}
  .meu-usu-icone > svg {
    font-size: 60px;
    margin-top: -4px;
    margin-left: -1px;
    color: #000;
    opacity: 0.60;
  }
  .meu-usu-icone > img {
    margin-top: -20px;
    margin-left: -20px;
    width: calc(100% + 40px);
    height: calc(100% + 40px);
    border-radius: 50%;
  }
</style>

<script>
  export default {
    props: {
      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        classes: [ 'usu-upl-img' ],
        imagem: '',
        requestId: '',
        disabled: false
      }
    },
    mounted: function () {
      this.usuarioUploadImagemIniciar()
    },
    methods: {
      usuarioUploadImagemIniciar: function () {
        // SETA A IMAGEM DO USUARIO
        if ([ '', null, undefined ].indexOf(this.$store.state.usuario.imagem) === -1) {
          this.imagem = this.$store.state.usuario.imagem
        }

        // SETA O STATUS DA TELA
        this.usuarioUploadImagemSetarStatusGeral('')

        // CHAMA A FUNÇÃO PARA INICIAR O OBSERVADOR
        this.usuarioUploadImagemObservadorIniciar()
      },
      usuarioUploadImagemSetarStatusGeral: function (status) {
        // SETA O STATUS DA PAGINA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      usuarioUploadImagemFechar: function (atualizar, id = '', vetor = null) {
        if (atualizar === true) {
          // INICIA AS CHAVES QUE DEVE SER ATUALIZADAS
          var chaves = [ 'usuario', 'usuarios', 'usuarios_reg_ate' ]

          // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
          const SESSAO_ATUALIZAR_VUEX = require('@/assets/js/Sessao.js').SESSAO_ATUALIZAR_VUEX

          // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS DA API
          SESSAO_ATUALIZAR_VUEX(chaves, () => { this.cpntFecharFormulario(atualizar, id, vetor) })
        } else {
          this.cpntFecharFormulario(atualizar, id, vetor)
        }
      },
      usuarioUploadImagemObservadorIniciar: function (tentativa = 0) {
        if (tentativa <= 10) {
          setTimeout(() => {
            if ([ '', null, undefined ].indexOf(this.$refs) !== -1 || [ '', null, undefined ].indexOf(this.$refs.drop) !== -1) {
              this.usuarioUploadImagemObservadorIniciar((tentativa + 1))
            } else {
              // SETA O EVENTO PARA 
              this.$refs.drop.addEventListener('dragover', this.usuarioUploadImagemDrag)

              // SETA O EVENTO PARA 
              this.$refs.drop.addEventListener('dragenter', this.usuarioUploadImagemDrag)

              // SETA O EVENTO PARA 
              this.$refs.drop.addEventListener('drop', this.usuarioUploadImagemDrag)
            }
          }, (tentativa === 0 ? 0 : 200))
        }
      },
      usuarioUploadImagemDrag: function (event) {
        // PARA A AÇÃO DO EVENTO
        event.stopPropagation()
        event.preventDefault()

        // VERIFICA SE ESTÁ DESABILITADO O CAMPO
        if (this.disabled === false) {
          // SETA O REQUEST ID
          var requestId = Math.floor(Math.random() * (9999 - 1000)) + 1000
  
          // SETA O VALOR GERADO
          this.requestId = requestId
  
          // VERIFICA O QUE DEVE SER REALIZADO
          switch (event.type) { 
            case 'dragover':
              // SETA AS CLASSES
              this.classes = [ 'usu-upl-img', 'usu-upl-img-dragover' ]
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
  
              // AGUARDA UM POUCO E CHAMA A FUNÇÃO PARA FECHAR O DRAG
              setTimeout(() => { this.usuarioUploadImagemLimparDrag(false, requestId) }, 200)
              break
  
            case 'dragenter':
              this.usuarioUploadImagemLimparDrag(true, requestId)
              break
  
            case 'drop':
              // SETA AS CLASSES
              this.classes = [ 'usu-upl-img', 'usu-upl-img-dragover' ]
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // SETA O STATUS DO CAMPO
              this.disabled = true

              // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
              this.usuarioUploadImagemLerArquivo(event.dataTransfer.files)
              break

            case 'change':
              // SETA AS CLASSES
              this.classes = [ 'usu-upl-img', 'usu-upl-img-dragover' ]
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // SETA O STATUS DO CAMPO
              this.disabled = true

              // PEGA O ARQUIVO
              var arquivo = [ '', null, undefined ].indexOf(event.clipboardData) === -1 ? event.clipboardData : event.target

              // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
              this.usuarioUploadImagemLerArquivo(arquivo.files)
              break
          }
        }
      },
      usuarioUploadImagemLimparDrag: function (forcar = false, requestId = '') {
        if (forcar === true || (forcar === false && this.requestId === requestId)) {
          // SETA A CLASSE DO CAMPO
          this.classes = [ 'usu-upl-img' ]
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      usuarioUploadImagemLerArquivo: function (files, index = 0, vetor = []) {
        if ([ '', null, undefined ].indexOf(files[index]) !== -1) {
          this.usuarioUploadImagemEnviarApi(vetor[0])
        } else {
          // INICIA O VETOR
          vetor[index] = {}

          // SETA A EXTENSAO DO ARQUIVO
          vetor[index].ext = files[index].name.match(/\.[0-9a-z]+$/i)

          // SETA A EXTENSÃO DO ARQUIVO ENCONTRADA
          vetor[index].ext = vetor[index].ext.length === 1 ? vetor[index].ext[0].substring(1, vetor[index].ext[0].length) : vetor[index].ext[0]

          // CONVERTE A STRING PARA MINUSCULA
          vetor[index].ext = vetor[index].ext.toLowerCase()

          // SETA O NOME DO ARQUIVO
          vetor[index].name = files[index].name

          // INICIA A LEITURA DO ARQUIVO
          var reader = new FileReader()

          // SETA FUNÇÃO DE SUCESSO DE LEITURA
          reader.onload = () => {
            // SETA A IMAGEM RECEBIDA
            vetor[index].conteudo_b64 = window.btoa(reader.result)
            vetor[index].conteudo = ('data:image/' + vetor[index].ext + ';base64, ' + vetor[index].conteudo_b64)

            // SETA O CONTEUDO GERADO
            this.imagem = vetor[index].conteudo

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.usuarioUploadImagemLerArquivo(files, (index + 1), vetor)
          }

          // FAZ A LEITURA DO ARQUIVO RECEBIDO
          reader.readAsBinaryString(files[index])
        }
      },
      usuarioUploadImagemEnviarApi: function (file) {
        // INICIA O VETOR QUE SERÁ ENVIADO PARA API
        var formData = { b64: file.conteudo_b64 }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI('/usuario/meu-usuario/imagem', 'PUT', formData, (apiSuccess) => {
          // TRATA A MENSAGEM RECEBIDA
          this.$store.state.TRATAR_RET_LOT_API(apiSuccess, null)

          // FECHA O FORMULARIO
          this.usuarioUploadImagemFechar(true, this.$store.state.token.clu_iu, file)
        }, this.usuarioUploadImagemSetarStatusGeral, (apiValid, apiStatus) => {
          this.$store.state.FUN_API_RET_VALIDA(this, 'formulario', apiValid, apiStatus, {}, true)
        })
      }
    }
  }
</script>
